import { render } from "./LeitnerBoxItems.vue?vue&type=template&id=5f521a1e&scoped=true&ts=true"
import script from "./LeitnerBoxItems.vue?vue&type=script&lang=ts"
export * from "./LeitnerBoxItems.vue?vue&type=script&lang=ts"

import "./LeitnerBoxItems.vue?vue&type=style&index=0&id=5f521a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f521a1e"]])

export default __exports__